<template>
  <e-dialog
    dialog-title="新增供应商"
    :center-dialog-visible="addSupplierVisible"
    popup-width="800px"
    destroy-close
    modal-append-to-body
    @resetPopupData="cancelHandle"
    @submitPopupData="submitData"
  >
    <div class="select-products">
      <e-search
        :data="listQuery"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleSearch"
        @handleReset="handleReset"
        @handleEvent="handleEvent"
      ></e-search>
      <div class="table-wrap">
        <div class="list-box">
          <!-- :checkSelectable="checkSelectable" -->
          <ETableList
            ref="tableData"
            :table-data="tableData"
            :table-label="tableLabel"
            :loading="tableLoading"
            :reserve-selection="true"
            max-height="252"
            height="252px"
            :row-key="idKey"
            selection-show
            @handleSelectionChange="selectionChange"
          >
            <template #productGrade="{ scope }">
              <eui-btn type="text" @click="companyDetail(scope.row.companyId)">查看详情</eui-btn>
            </template>
            <template #compliance="{ scope }">
              <el-rate
                v-model="scope.row.compliance"
                disabled
                :colors="['#f78515', '#f78515', '#f78515']"
                void-color="#dcdcdc"
              ></el-rate>
            </template>
            <template #innovationEvaluate="{ scope }">
              <el-rate
                v-model="scope.row.innovationEvaluate"
                disabled
                :colors="['#55B3CF', '#55B3CF', '#55B3CF']"
                void-color="#dcdcdc"
              ></el-rate>
            </template>
          </ETableList>
        </div>
        <div class="pagination">
          <span class="has-selected">已选 {{ multipleSelectionAll.length }} 家</span>
          <el-pagination
            :pager-count="5"
            layout="prev, pager, next, total, jumper"
            :current-page="listQuery.pageNum"
            :total="total"
            :page-size.sync="listQuery.pageSize"
            prev-text="上一页"
            next-text="下一页"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <e-dialog
      dialog-title="产品质量评价详情"
      :center-dialog-visible="detailVisible"
      popup-width="560px"
      show-close-btn
      :show-btn="false"
      @updateVisible="detailVisible = false"
      @resetPopupData="detailVisible = false"
      @submitPopupData="detailVisible = false"
    >
      <ETableList :table-data="detailTableData" :table-label="detailTableLabel"></ETableList>
      <div class="pagination">
        <el-pagination
          :pager-count="5"
          layout="total, prev, pager, next"
          :current-page="detailQuery.pageNum"
          :total="detailTotal"
          :small="true"
          :page-size.sync="detailQuery.pageSize"
          @size-change="detailHandleSizeChange"
          @current-change="detailHandleCurrentChange"
        ></el-pagination>
      </div>
    </e-dialog>
  </e-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/enquiry';
import userApi from '@/modules/projectA/api/user';
import ETableList from '@/modules/projectA/components/common/e-table-list';
import EDialog from '@/modules/projectA/components/common/e-dialog';
import ESearch from '@/modules/projectA/components/common/e-search.vue';
import _ from 'lodash';
import multipleSelection from '../mixins/multipleSelection.js';

export default {
  components: {
    ETableList,
    EDialog,
    ESearch,
  },
  mixins: [multipleSelection],
  props: {},
  data() {
    return {
      idKey: 'companyId',
      addSupplierVisible: false,
      cloneSupplierForm: {},
      // 公司列表参数
      tableLoading: false,
      total: 0,
      selectedList: [],
      tableData: [],
      tableLabel: [
        {
          label: '供应商名称',
          param: 'companyName',
          align: 'center',
          minWidth: 230,
          fixed: 'left',
          tooltip: true,
        },
        {
          label: '行业',
          param: 'classificationName',
          align: 'center',
          minWidth: 150,
          tooltip: true,
        },
        {
          label: '易派客标准指数',
          param: 'scoreAll',
          align: 'center',
          minWidth: 120,
        },
        {
          label: '产品质量评价',
          align: 'center',
          minWidth: 120,
          slot: 'productGrade',
        },
        {
          label: '法人信用认证',
          align: 'center',
          param: 'creditGrade',
          minWidth: 120,
        },
        {
          label: '履约动态考评',
          align: 'center',
          minWidth: 160,
          slot: 'compliance',
        },
        {
          label: '市场业绩表现',
          align: 'center',
          minWidth: 160,
          slot: 'innovationEvaluate',
        },
      ],
      listQuery: {
        companyName: '',
        scoreAllMin: '',
        scoreAllMax: '',
        creditGrade: '',
        pageNum: 1,
        pageSize: 10,
      },
      filterInfo: {
        fieldList: [
          { label: '供应商名称', type: 'input', value: 'companyName' },
          /*  { label: '行业', type: 'input', value: 'classificationName' }, */
          {
            label: '行业分类',
            type: 'cascader',
            value: 'classificationNameAl',
            list: 'classificationNameList',
            props: {
              checkStrictly: true,
              children: 'childList',
              value: 'classificationCode',
              label: 'classificationName',
            },
          },
          {
            label: '法人信用认证',
            type: 'select',
            value: 'creditGrade',
            list: 'creditArr',
          },
          {
            label: '易派客标准指数',
            type: 'numRange',
            value1: 'scoreAllMin',
            value2: 'scoreAllMax',
            rangeWidth: 'min-width',
          },
        ],
        count: 3,
        btnStyle: [
          { icon: 'el-icon-search', text: '搜索', type: 'primary' },
          { icon: 'el-icon-refresh', text: '重置' },
        ],
      },
      listTypeInfo: {
        creditArr: [
          {
            id: '',
            name: '全部等级',
          },
          {
            id: 'AAA+',
            name: 'AAA+',
          },
          {
            id: 'AAA',
            name: 'AAA',
          },
          {
            id: 'AA+',
            name: 'AA+',
          },
          {
            id: 'AA',
            name: 'AA',
          },
          {
            id: 'AA-',
            name: 'AA-',
          },
          {
            id: 'A+',
            name: 'A+',
          },
          {
            id: 'A',
            name: 'A',
          },
          {
            id: 'A-',
            name: 'A-',
          },
          {
            id: 'BBB+',
            name: 'BBB+',
          },
          {
            id: 'BBB',
            name: 'BBB',
          },
          {
            id: 'BBB-',
            name: 'BBB-',
          },
          {
            id: 'BB+',
            name: 'BB+',
          },
          {
            id: 'BB',
            name: 'BB',
          },
          {
            id: 'BB-',
            name: 'BB-',
          },
          {
            id: 'B+',
            name: 'B+',
          },
          {
            id: 'B',
            name: 'B',
          },
          {
            id: 'B-',
            name: 'B-',
          },
          {
            id: 'CCC+',
            name: 'CCC+',
          },
          {
            id: 'CCC',
            name: 'CCC',
          },
          {
            id: 'CCC-',
            name: 'CCC-',
          },
          {
            id: 'CC+',
            name: 'CC+',
          },
          {
            id: 'CC',
            name: 'CC',
          },
          {
            id: 'CC-',
            name: 'CC-',
          },
          {
            id: 'C+',
            name: 'C+',
          },
          {
            id: 'C',
            name: 'C',
          },
          {
            id: 'C-',
            name: 'C-',
          },
        ],
        classificationNameList: [],
      },
      // 详情列表参数
      detailVisible: false,
      detailTableData: [],
      detailLoading: false,
      detailQuery: {
        pageNum: 1,
        pageSize: 10,
        companyId: -1,
      },
      detailTotal: 0,
      detailTableLabel: [
        {
          label: '商品类目',
          param: 'categoryDescription',
          align: 'center',
          minWidth: 200,
        },
        {
          label: '产品质量评价分数',
          param: 'productEvaluate',
          align: 'center',
          minWidth: 200,
        },
      ],
    };
  },
  watch: {},
  methods: {
    handleEvent(e, obj) {
      if (e.label === 'classificationNameAl') {
        if (e.value.length === 1) {
          this.listQuery.secondClassificationCode = '';
          const [firstClassificationCode] = e.value;
          this.listQuery.firstClassificationCode = firstClassificationCode;
        } else {
          this.listQuery.firstClassificationCode = '';
          const [, secondClassificationCode] = e.value;
          this.listQuery.secondClassificationCode = secondClassificationCode;
        }
      }
      console.log(this.listQuery);
      console.log(e, obj);
    },
    async getTree() {
      const res = await userApi.queryTree();
      if (res.code === '200') {
        this.listTypeInfo.classificationNameList = res.data.childList;
      }
    },
    initData() {
      this.addSupplierVisible = true;
      this.cloneSupplierForm = _.cloneDeep(this.listQuery);
      this.getList(this.listQuery);
      this.getTree();
    },
    selectionChange(val) {
      this.multipleSelection = [...val];
      this.getAllSelectionData();
    },
    // 获取全部 列表数据
    async getList(params) {
      this.tableLoading = true;
      await userApi.queryCompanyGradeAllPage(params).then((res) => {
        this.tableLoading = false;
        if (res.code === '200') {
          const list = res.data?.records;
          list.forEach((item) => {
            item.complianceAlias = item.compliance;
            item.innovationEvaluateAlias = item.innovationEvaluate;
            item.innovationEvaluate = item.innovationEvaluate
              ? this.innovationEvaluate(Number(item.innovationEvaluate))
              : item.innovationEvaluate;

            item.compliance = item.compliance ? this.compliance(Number(item.compliance)) : item.compliance;
          });
          this.tableData = [...list];
          this.total = res.data?.total;
          this.setSelectRow();
          // this.$nextTick(this.$refs.leftTable.$refs.table.clearSelection());
        }
      });
    },
    // 处理市场业绩
    innovationEvaluate(score) {
      /* if (score >= 0 && score < 10) {
        return 1;
      }
      if (score >= 10 && score < 20) {
        return 2;
      }
      if (score >= 20 && score < 40) {
        return 3;
      }
      if (score >= 40 && score < 60) {
        return 4;
      }
      if (score >= 60) {
        return 5;
      } */
      switch (true) {
        case score >= 0 && score < 10:
          return 1;
        case score >= 10 && score < 20:
          return 2;
        case score >= 20 && score < 40:
          return 3;
        case score >= 40 && score < 60:
          return 4;
        default: // 当 score >= 60
          return 5;
      }
    },
    // 履约
    compliance(score) {
      return score / 5;
    },

    // 获取公司详情数据
    async getCompanyDetailList(params) {
      this.detailLoading = true;
      await Api.queryCompanyProductGradePage(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          console.log(res, '收藏列表数据');
          const list = res.data?.records;
          this.detailTableData = [...list];
          this.detailTotal = res.data?.total;
        }
      });
    },
    // 内层弹窗
    companyDetail(companyId) {
      this.detailQuery.companyId = companyId;
      this.detailVisible = true;
      this.getCompanyDetailList(this.detailQuery);
    },
    // 搜索
    handleSearch(val) {
      this.listQuery = { ...this.listQuery, ...val };
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    // 重置
    handleReset() {
      // console.log({ ...this.cloneSupplierForm });
      this.listQuery = { ...this.cloneSupplierForm };
      this.getList(this.listQuery);
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    cancelHandle() {
      this.listQuery = { ...this.cloneSupplierForm };
      this.addSupplierVisible = false;
      this.clearTable();
    },
    // 点击确定 获取到选择的供应商
    submitData() {
      if (!this.multipleSelectionAll.length) {
        this.$message.error('请选择供应商');
        return;
      }
      userApi
        .batchInsert({
          companyIdList: this.multipleSelectionAll.map((item) => item.companyId),
        })
        .then((res) => {
          if (res.code === '200') {
            this.$message.success('新增供应商成功');
            this.cancelHandle();
            this.$emit('handleSuccess');
          }
        });
    },
    detailHandleCurrentChange(val) {
      this.detailQuery.pageNum = val;
      this.getCompanyDetailList(this.detailQuery);
    },
    detailHandleSizeChange(val) {
      this.detailQuery.pageSize = val;
      this.detailQuery.pageNum = 1;
      this.getCompanyDetailList(this.detailQuery);
    },
  },
};
</script>
<style lang="scss">
.select-products {
  .search-content {
    margin-bottom: 20px;
    //padding: 20px;
    //::v-deep .el-form-item--small.el-form-item {
    //  margin-bottom: 10px;
    //  margin-right: 20px;
    //}
  }
  .el-checkbox__label {
    font-weight: normal;
  }
  .pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .has-selected {
      color: #333;
      font-family: Source Han Sans CN;
      font-size: 14px;
      font-style: normal;
      font-weight: 350;
    }
  }
}
.pagination {
  margin-bottom: 0 !important;
}
.comn_dialog .el-dialog__body {
  padding-bottom: 0;
}
.el-pagination__jump {
  margin-left: 0;
}
</style>
